import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { resolveDocumentTitle } from 'components/TitleUpdater';

export default function TitleLayout() {
  const location = useLocation();

  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.title = resolveDocumentTitle(location?.pathname || '');
  }, [location]);

  return <Outlet />;
}
